import * as ApiClient from '@arbihunter/api-client';
import {
  createConfiguration,
  Middleware,
  RequestContext,
  ServerConfiguration,
} from '@arbihunter/api-client';

type ApiConstructor<T = any> = new (configuration: ApiClient.Configuration) => T;

export type AdminApis = { [key: string]: any };
export type ClientApis = { [key: string]: any };

export class Api {
  private static instance: Api;
  private config: ApiClient.Configuration;
  private apiInstances: Map<string, any> = new Map();

  public admin: AdminApis = {};
  public client: ClientApis = {};

  private constructor() {
    // promiseMiddleware: Middleware[] = [], // middlewares: Middleware[] = [], // baseUrl: string,
    const baseUrl: string = process.env.HOST || 'http://localhost:3000';
    const configParams = this.createConfigurationParams(baseUrl);
    // const configParams = this.createConfigurationParams(baseUrl, middlewares, promiseMiddleware);
    this.config = createConfiguration(configParams);
    this.initializeApiClients();
  }

  private createConfigurationParams(
    baseUrl: string,
    middlewares: Middleware[] = [],
    promiseMiddleware: Middleware[] = [],
  ) {
    const server = new ServerConfiguration(baseUrl, {});
    const baseServer = {
      ...server,
      url: baseUrl,
      makeRequestContext: (endpoint: string, httpMethod: ApiClient.HttpMethod): RequestContext => {
        const url = `${baseUrl}${endpoint}`;

        const requestContext = new RequestContext(url, httpMethod);

        // for (const middleware of middlewares) {
        //   requestContext = await middleware.pre(requestContext);
        // }

        return requestContext;
      },
    };
    return { baseServer, middlewares, promiseMiddleware };
  }

  private isApiClass(obj: any): obj is ApiConstructor {
    return (
      typeof obj === 'function' &&
      /Api$/.test(obj.name) &&
      typeof obj.prototype === 'object' &&
      obj.prototype.constructor === obj
    );
  }

  private initializeApiClients(): void {
    for (const key in ApiClient) {
      try {
        const exportedItem = (ApiClient as any)[key];
        if (this.isApiClass(exportedItem)) {
          const apiInstance = new exportedItem(this.config);
          this.apiInstances.set(key, apiInstance);
          const isAdminApi = key.startsWith('ADMIN') || key.includes('AdminApi');
          let shortName: string;
          if (isAdminApi) {
            shortName = key.replace(/^ADMIN(.+)Api$/, '$1');
            if (shortName === key) {
              shortName = key.replace(/(.+)AdminApi$/, '$1');
            }
          } else {
            shortName = key.replace(/(.+)Api$/, '$1');
          }
          shortName = shortName.charAt(0).toLowerCase() + shortName.slice(1);
          if (isAdminApi) {
            this.admin[shortName] = apiInstance;
          } else {
            this.client[shortName] = apiInstance;
          }
        }
      } catch (error) {
        console.error(`Ошибка при создании API-класса ${key}:`, error);
      }
    }
  }

  public static get i(): Api {
    if (!Api.instance) {
      Api.instance = new Api();
    }
    return Api.instance;
  }

  public run<T>(apiClass: ApiConstructor<T>): T {
    const className = apiClass.name;
    if (this.apiInstances.has(className)) {
      return this.apiInstances.get(className);
    }
    console.log(`API Config middlewares:`, this.config.middleware, this.config.authMethods);
    const instance = new apiClass(this.config);
    this.apiInstances.set(className, instance);
    return instance;
  }

  public updateConfig(
    baseUrl: string,
    middlewares: Middleware[] = [],
    promiseMiddleware: Middleware[] = [],
  ): void {
    const configParams = this.createConfigurationParams(baseUrl, middlewares, promiseMiddleware);
    this.config = createConfiguration(configParams);

    this.apiInstances.clear();
    this.admin = {};
    this.client = {};

    this.initializeApiClients();
  }

  // public setAuthToken(token: string | null): void {
  //   if (typeof localStorage !== 'undefined') {
  //     if (token) {
  //       localStorage.setItem('auth_token', token);
  //     } else {
  //       localStorage.removeItem('auth_token');
  //     }
  //   }
  // }

  // public getAuthToken(): string | null {
  //   if (typeof localStorage !== 'undefined') {
  //     return localStorage.getItem('auth_token');
  //   }
  //   return null;
  // }
}

const api = Api.i;
// const api = new Api(process.env.HOST || 'http://localhost:3000', [], []);
export { api };
